"use client";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocaleRouter } from '@/hooks/useLocaleRouter';
// import YouTubeVideoBackground from './YouTubeVideoBackground';
// import NativeVideoBackground from './NativeVideoBackground';
import CloudflareStreamBackground from './CloudflareStreamBackground';
import { Title, Text } from '@/components/ui/Headings';

const VideoHero = () => {
  const { t } = useTranslation();
  const { createLocalizedPath } = useLocaleRouter();

  // YouTube video ID (commented out)
  // const youTubeId = "dvYlALjKU-Q";
  
  // Pexels video (commented out)
  // const videoSrc = "https://videos.pexels.com/video-files/31223127/13336202_1920_1080_60fps.mp4";
  // const posterSrc = "https://images.pexels.com/videos/31223127/pexels-photo-31223127.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080";
  
  // Cloudflare Stream video
  const cloudflareVideoId = "21496071ee16670e2d9a87541491f1e4";
  const cloudflareCustomerSubdomain = "customer-tsbwdul1oclpm8sd";
  const posterSrc = "https://images.pexels.com/videos/31223127/pexels-photo-31223127.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080";

  return (
    <section
      className="relative flex items-center justify-center overflow-hidden h-[75vh] sm:h-[80vh] lg:h-[85vh]"
      style={{ paddingTop: "80px" }}
    >
      {/* Video Background - Cloudflare Stream */}
      <CloudflareStreamBackground 
        videoId={cloudflareVideoId}
        customerSubdomain={cloudflareCustomerSubdomain}
        posterSrc={posterSrc}
      />
      
      {/* Other implementations (commented out) */}
      {/* <YouTubeVideoBackground videoId={youTubeId} /> */}
      {/* <NativeVideoBackground videoSrc={videoSrc} posterSrc={posterSrc} /> */}

      {/* Content */}
      <div className="relative z-10 text-center text-white px-5 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <Title size="xl" className="text-white font-semibold mb-4 sm:mb-5 lg:mb-6 animate-fade-in drop-shadow-2xl leading-[1.15]">
          {t("hero.titleLine1")}
          <br />
          <span className="text-neutral-cream">{t("hero.titleLine2")}</span>
        </Title>
        <Text variant="body" className="font-medium mb-6 sm:mb-8 lg:mb-10 text-white animate-slide-up drop-shadow-2xl max-w-3xl mx-auto leading-relaxed">
          {t("hero.subtitle")}
        </Text>
        <Link
          href={createLocalizedPath("/about")}
          className="inline-flex items-center px-6 lg:px-8 py-2.5 lg:py-3 rounded-full text-sm lg:text-base font-bold transition-all duration-300 transform hover:scale-105 animate-slide-up shadow-2xl border-2 bg-transparent hover:bg-white hover:text-primary-900 group touch-target"
          style={{
            color: "#cdc50a",
            borderColor: "#cdc50a",
            backgroundColor: "transparent",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#cdc50a";
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.borderColor = "white";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#cdc50a";
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.borderColor = "#cdc50a";
          }}
        >
          {t("hero.cta")}
          <ArrowRight className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" />
        </Link>
      </div>
    </section>
  );
};

export default VideoHero;